"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowFactory = exports.SHOW_THEME_EDITOR = exports.SHOW_EXPORT_TABLE = exports.SHOW_PIVOT_COLUMN_DETAILS = exports.WINDOW_GRID_FILTER_EDITOR = void 0;
const GridFilterWindowPopup_1 = require("../../../GridFilter/GridFilterWindowPopup");
const PivotDetailsPopoup_1 = require("../../../Layout/PivotDetailsPopoup");
const ExportTablePopup_1 = require("../../../Export/ExportTablePopup");
const ThemeEditorWindow_1 = require("../../../Theme/ThemeEditorWindow");
exports.WINDOW_GRID_FILTER_EDITOR = 'WINDOW_GRID_FILTER_EDITOR';
exports.SHOW_PIVOT_COLUMN_DETAILS = 'SHOW_PIVOT_COLUMN_DETAILS';
exports.SHOW_EXPORT_TABLE = 'SHOW_EXPORT_TABLE';
exports.SHOW_THEME_EDITOR = 'SHOW_THEME_EDITOR';
exports.windowFactory = {
    [exports.WINDOW_GRID_FILTER_EDITOR]: GridFilterWindowPopup_1.GridFilterWindowPopup,
    [exports.SHOW_PIVOT_COLUMN_DETAILS]: PivotDetailsPopoup_1.PivotDetailsPopoup,
    [exports.SHOW_EXPORT_TABLE]: ExportTablePopup_1.ExportTablePopup,
    [exports.SHOW_THEME_EDITOR]: ThemeEditorWindow_1.ThemeEditorWindow,
};
